"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelperTextWrapper = exports.ExclamationMark = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const ExclamationMark = exports.ExclamationMark = (0, _mui.styled)(_icons.ErrorCircleFilled)(({
  theme
}) => ({
  width: 28,
  height: 28,
  marginLeft: theme.spacing(2),
  color: theme.palette.error.main
}));

// TODO: this is wrong from accessibility perspective
const HelperTextWrapper = exports.HelperTextWrapper = (0, _mui.styled)('div')({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
});